const testingURL = "http://localhost:3000";
const productionURL = "https://lionfish-app-fi4sg.ondigitalocean.app";

exports.endpointURL = productionURL; //productionURL;
